export const GLOBAL_STATE = 'ModulesOutcome'

export const MODULES_OUTCOME = 'MODULES_OUTCOME' as const
export const MODULES_OUTCOME_CREATE = 'MODULES_OUTCOME_CREATE' as const
export const MODULES_OUTCOME_LIST = 'MODULES_OUTCOME_LIST' as const
export const MODULES_OUTCOME_RECALCULATE = 'MODULES_OUTCOME_RECALCULATE' as const
export const CANCEL_MODULES_OUTCOME = 'CANCEL_MODULES_OUTCOME' as const
